import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    { question: "Do I need to install anything?", answer: "No. Twinnee works right in your phone or computer's browser — nothing to download. Our platform is built on modern web standards to ensure a seamless experience across all your high-end creative devices." },
    { question: "Do I need to know how to write prompts?", answer: "Not at all. Twinnee's intuitive visual selectors and Director AI assist you every step of the way. Simply pick your vibe, style, and characters, or type a simple sentence." },
    { question: "Is my photo safe?", answer: "Yes, 100%. Your photos and generated assets are encrypted and strictly private. We never share or sell your likeness or data to third parties." },
    { question: "What if I need help?", answer: "Our dedicated 24/7 human support team and active Discord creator community are always available to help you troubleshoot, optimize prompts, and guide your projects." },
  ];

  return (
    <section id="faq" className="text-white py-28 sm:py-32 px-4 sm:px-6 lg:px-8 font-sora relative overflow-hidden">
      <div className="max-w-3xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-14 sm:mb-16">
          <p className="text-xs font-semibold tracking-widest text-[#62FAE3] uppercase mb-4 font-mono">SUPPORT CENTER</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white mb-4">
            Frequently{" "}<span className="bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Asked Questions</span>
          </h2>
          <p className="text-gray-400 text-xs sm:text-sm font-light leading-relaxed max-w-lg mx-auto">
            Everything you need to know about the next generation of AI-driven cinematic storytelling.
          </p>
        </div>

        <div className="flex flex-col gap-4 sm:gap-5">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="rounded-2xl border border-white/[0.08] bg-[#13151c]/90 backdrop-blur-xl transition-all duration-300 overflow-hidden shadow-lg hover:border-white/15">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 sm:py-5.5 text-left flex items-center justify-between gap-4 cursor-pointer">
                  <span className="text-sm sm:text-base font-semibold text-white tracking-tight">{faq.question}</span>
                  {isOpen ? <ChevronUp className="w-4 h-4 text-[#62FAE3] shrink-0" /> : <ChevronDown className="w-4 h-4 text-gray-400 shrink-0" />}
                </button>
                {isOpen && <div className="px-6 pb-6 pt-1 text-xs sm:text-sm text-gray-300 leading-relaxed font-light">{faq.answer}</div>}
              </div>
            );
          })}
        </div>

        <div className="mt-16 sm:mt-20 flex justify-center">
          <div className="w-full max-w-[520px] rounded-[20px] bg-[#18191f] py-10 px-8 text-center">
            <h3 className="text-2xl sm:text-[28px] font-bold tracking-tight leading-snug">
              <span className="bg-gradient-to-r from-[#C4AAFF] via-[#7EE8DF] to-[#5BE6D6] bg-clip-text text-transparent">Still have questions?</span>
            </h3>
            <p className="mt-3 text-[#9CA3AF] text-sm font-normal max-w-xs mx-auto leading-relaxed">Our team is ready to help you push the boundaries of digital narrative.</p>
            <div className="mt-7">
              <a href="mailto:support@twinnee.com" className="inline-flex items-center justify-center px-7 py-3 rounded-full bg-[#252830] hover:bg-[#2e3040] border border-white/10 hover:border-white/20 text-white text-sm font-medium tracking-wide transition-all duration-200 active:scale-95 cursor-pointer">
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
